import { PRO_GRANT_AI_CREDITS } from 'src/components/buyCreditsDialog/benefits';
import { useAppSelector } from 'src/redux';

/** What a Pro tier's monthly AI-credit grant buys, at today's prices:
 * tailored resumes (a score plus a tailor each) or cover letters. */
const useAiGrantMath = (credits: number = PRO_GRANT_AI_CREDITS) => {
  // Score + tailor: a job's tailored resume needs both, in AI credits.
  const tailorFee = useAppSelector(
    (state) =>
      (state.appState.constants?.credits?.ResumeAnalysis ?? 20) +
      (state.appState.constants?.credits?.ResumeEnhance ?? 30),
  );
  const coverLetterFee = useAppSelector(
    (state) => state.appState.constants?.credits?.CoverLetter ?? 10,
  );
  const scoreFee = useAppSelector(
    (state) => state.appState.constants?.credits?.ResumeAnalysis ?? 20,
  );
  const refineFee = useAppSelector(
    (state) => state.appState.constants?.credits?.CoverLetterRefine ?? 5,
  );
  const per = (fee: number) => Math.floor(credits / (fee || 1));
  return {
    credits,
    tailors: per(tailorFee),
    letters: per(coverLetterFee),
    scores: per(scoreFee),
    refines: per(refineFee),
    fees: {
      tailor: tailorFee,
      letter: coverLetterFee,
      score: scoreFee,
      refine: refineFee,
    },
  };
};

export default useAiGrantMath;
